module.exports = __webpack_public_path__ + "files/ff9518324927a65778740f4db05da66d.png";